import { Helmet } from 'react-helmet-async';

const SEOHead = ({ title, description, path = '', image, keywords, jsonLd }) => {
  const siteName = 'OsakaConnect';
  const baseUrl = 'https://www.osakaconnect.com';
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} — World's First Travel Hypermarket & AI-Powered Super App`;
  const desc = description || "OsakaConnect is the world's first AI-powered Travel Hypermarket offering 24+ travel products — flights, hotels, visa, insurance, cruises, and more — through one unified platform for B2B agents, corporates, and travellers worldwide.";
  const url = `${baseUrl}${path}`;
  const ogImage = image || `${baseUrl}/og-default.png`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={siteName} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
      {jsonLd && (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map((schema, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(schema)}</script>
      ))}
    </Helmet>
  );
};

export default SEOHead;
